var render = function render(){var _vm=this,_c=_vm._self._c;return _c('batch-actions-button',{attrs:{"batch-actions":_vm.batchActions,"single-mode-identifier-object":_vm.selectedValue,"button-label":"Action"},on:{"executed":function($event){return _vm.$emit('executed', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }